module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Home/Bag-chair-7a0c99a4309e85012bc9561b7d90f373.svg";